import { jsx as _jsx } from "react/jsx-runtime";
import ShareSVG from "../icons/share.svg";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";
export const ShareButton = ({ onClick }) => {
    const translations = useTranslations();
    return (_jsx(PlayerControlButtonComponent, { "aria-label": translations("player__a11y__voice_over_open_share_menu_button"), onClick: onClick, Icon: _jsx(ShareSVG, {}), interactive: true, hoverText: translations("player__a11y__hover_label_share_button") }));
};
